import React, { Component } from 'react';
import platform from "Pub/js/platform";
import ajax from "Pub/js/ajax";
import { langCheck } from "Pub/js/utils";
const { NCDropdown, NCButton, NCIcon } = platform.base;

class SearchSelect extends Component {
    constructor(props) {
        super(props);
        this.state = { visible: false };
    }
    handleSelect = () => {
        let { selects, onSelectsSet } = this.props;
        let data = [
            { id: "all", name: langCheck("0000PUB-000536") }, /* 国际化处理： 全部*/
            { id: "bd_apply", name: langCheck("0000PUB-000537") }, /* 国际化处理： 应用*/
        ];

        if (!selects.length) { //避免重复请求
            ajax({
                url: "/nccloud/uapss/gsc/querySourceGroup.do",
                data: null,
                success: res => {
                    if (res && res.data) {
                        res.data.data = selects.concat(data, res.data.data);
                        onSelectsSet(res.data.data);
                    }
                },
                error: () => {
                    onSelectsSet(data);
                    console.log("请求领域搜索类型失败");
                },
            });
        }
    }
    handleVisibleChange = visible => {
        this.setState({ visible });
    }
    render() {
        let { onSelect, selects, displayInfo } = this.props;
        let { key, label } = displayInfo;

        return <div className='select-left' ref={ref => this.searchSelectRef = ref}>
            <NCDropdown
                getPopupContainer={() => this.searchSelectRef}
                trigger={['click']}
                visible={this.state.visible}
                overlay={<ul>
                    {selects.map(item => {
                        let { id, name } = item;
                        return <li
                            className={`${id === key ? 'select-text-background' : 'select-text'}`}
                            key={id}
                            onClick={() => {
                                onSelect({
                                    key: id,
                                    label: name,
                                });
                            }}
                        >
                            <p
                            >
                                {name}
                            </p>
                        </li>;
                    })}
                </ul>}
                animation="slide-up"
                overlayClassName="search-select"
            >
                <div
                    tabIndex="1" //解决iframe内点击下拉框不关闭
                    className='select-left-content'
                    onClick={() => { 
                        this.handleVisibleChange(!this.state.visible); 
                    }}
                    onBlur={() => { setTimeout(() => { this.handleVisibleChange(false); }, 200); }}
                >
                    <NCButton
                        className="select-button"
                        onClick={this.handleSelect}
                    >
                        {label}
                        <NCIcon type='uf-arrow-down' className={`icon ${this.state.visible? 'rotate':'' }`} />
                    </NCButton>
                </div>

            </NCDropdown>
        </div>;
    }
}

export default SearchSelect;